module.exports = __webpack_public_path__ + "assets/images/BSD5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BSD5.png
// module id = 1318
// module chunks = 1